import { Type } from '@angular/core';
import { CompanyWizardComponent } from 'wizards/entity-wizards/company-wizard/company-wizard.component';

export enum EntityWizardTypes {
  company = 0
}

export type EntityWizardComponentTypes = Type<CompanyWizardComponent>;

export function getEntityWizardByType(type?: EntityWizardTypes): EntityWizardComponentTypes {
  // If add new EntityWizardTypes - add conditions for new entity
  return CompanyWizardComponent;
}
